/** Mesmo conteúdo de `environment.ts` — usado com `ng serve --configuration=dev`. */
export const environment = {
  production: false,
  functionKey: 'pGY8GUIYqlZTEwH9KDooolRTppZDNtxwaOMcBBOXAXvCAzFuaKNe-w==',
  /** Function key do Schedule (Azure Functions direto — AuthorizationLevel.Function). */
  scheduleFunctionKey: 'vLhFgTdAp-NkocF13S5AB_kTs06kRxizLTrg-HRpa4fkAzFuWzgG4w==',
  shoppingPurchaseOrdersListCode: '',
  apiUrl: 'https://api-loca9-erpdev.azure-api.net/loca9',
  microservices: {
    contract: 'https://erp-dev-contract-cffsemfmgbdca6er.brazilsouth-01.azurewebsites.net/api',
    template: 'https://erp-dev-contract-cffsemfmgbdca6er.brazilsouth-01.azurewebsites.net/api',
    product: 'https://erp-dev-contract-cffsemfmgbdca6er.brazilsouth-01.azurewebsites.net/api',
    staff: 'https://api-loca9-erpdev.azure-api.net/erp-dev-rh',
    customer: 'https://api-loca9-erpdev.azure-api.net/erp-dev-commercial',
    rental: 'https://api-loca9-erpdev.azure-api.net/erp-dev-rental',
    vehicles: 'https://api-loca9-erpdev.azure-api.net/erp-dev-vehicle',
    financial: 'https://erp-dev-financial-htf4c0cwgfhfhbf9.brazilsouth-01.azurewebsites.net/api',
    stock: 'https://api-loca9-erpdev.azure-api.net/erp-dev-stock',
    shopping: 'https://api-loca9-erpdev.azure-api.net/erp-dev-shopping',
    operation: 'https://api-loca9-erpdev.azure-api.net/erp-dev-operation',
    order: 'https://erp-dev-order-edfxgvg3evhuc0cj.brazilsouth-01.azurewebsites.net/api',
    user: 'https://api-loca9-erpdev.azure-api.net/erp-dev-user',
    auth: 'https://api-loca9-erpdev.azure-api.net/erp-dev-auth',
    schedule: 'https://erp-dev-schedule-axatfnahf6cfexhd.brazilsouth-01.azurewebsites.net/api',
    payment: 'https://erp-payment-fhggg8brfed3crav.brazilsouth-01.azurewebsites.net/api?code=fg-vIeVceNPztATNt_FsLkw21IyR9tpsqoX4duLbO2eBAzFuIK1AxA==',
    mobile: 'https://api-loca9-erpdev.azure-api.net/loca9',
    config: 'https://erp-dev-config-e3g0hcaddphcb3g0.brazilsouth-01.azurewebsites.net/api',
    profileGroup: 'https://api-loca9-erpdev.azure-api.net/erp-dev-user',
    b2bAuth: 'https://erp-dev-b2b-auth-g7ejgyeagghhgha8.canadacentral-01.azurewebsites.net/api',
  }
};
